// ContabilidadXL utils - Sprint 44 Fase 3 Vista 8.
// Helpers comunes: formatters, mapping de tipos/estados.

export function fmt(value, dec) {
  if (value === null || value === undefined || value === '') return '\u2014';
  const n = Number(value);
  if (Number.isNaN(n)) return '\u2014';
  const d = dec === 0 ? 0 : 2;
  return n.toLocaleString('es-CO', {
    minimumFractionDigits: d, maximumFractionDigits: d,
  });
}

export const TIPO_VARIANT = {
  activo: 'info',
  pasivo: 'warning',
  patrimonio: 'indigo',
  ingreso: 'success',
  gasto: 'danger',
};

export const TIPO_OPTIONS = [
  { value: '',           label: 'Todos los tipos' },
  { value: 'activo',     label: 'Activo' },
  { value: 'pasivo',     label: 'Pasivo' },
  { value: 'patrimonio', label: 'Patrimonio' },
  { value: 'ingreso',    label: 'Ingreso' },
  { value: 'gasto',      label: 'Gasto' },
];

export const TIPO_OPTIONS_FORM = TIPO_OPTIONS.filter((o) => o.value);

export const ACTIVO_OPTIONS = [
  { value: 'true',  label: 'Solo activas' },
  { value: 'false', label: 'Solo inactivas' },
  { value: '',      label: 'Todas' },
];

export const ESTADO_VARIANT = {
  borrador:  'neutral',
  publicado: 'success',
};
export const ESTADO_LABEL = {
  borrador:  'Borrador',
  publicado: 'Publicado',
};

export const ESTADO_OPTIONS = [
  { value: '',          label: 'Todos los estados' },
  { value: 'borrador',  label: 'Borrador' },
  { value: 'publicado', label: 'Publicado' },
];

export const MODULO_OPTIONS = [
  { value: '',              label: 'Todos los modulos' },
  { value: 'manual',        label: 'Manual' },
  { value: 'ventas',        label: 'Ventas' },
  { value: 'kardex',        label: 'Kardex' },
  { value: 'importaciones', label: 'Importaciones' },
  { value: 'compras',       label: 'Compras' },
];
